import config from "../config"
const baseUrl = config.base_url + "z_foundation/"
export default {
    // 流式导入 shp 并完成 sync + 农场初始化（SSE）
    importShp: {
        url: baseUrl + "importShp",
        type: "post",
    },
}
